import { useEffect, useCallback } from 'react';
import { Message } from 'botframework-directlinejs';
import { IFeedbackInitOptions } from './FeedbackTypes';
import { InAppFeedBackInfo, initializeInAppFeedback as defaultInitializeInAppFeedback, updateFeedbackOptions as defaultUpdateFeedbackOptions } from './CentroFeedbackFunctions';
import { IFeedbackData } from '../FeedbackButtons';
import { IConversationThreadProps } from '../types';

export interface IOCVFeedback {
  updateFeedbackOptions?: typeof defaultUpdateFeedbackOptions;
  initializeInAppFeedback?: typeof defaultInitializeInAppFeedback;
  thumbDownFeedbackOptions?: IFeedbackInitOptions;
  thumbUpFeedbackOptions?: IFeedbackInitOptions;
  productFeedbackOptions?: IFeedbackInitOptions;
  onFeedbackButtonClick?: IConversationThreadProps['onFeedbackButtonClick'];
  locale?: string,
}

export const getHostName = (props: IOCVFeedback) => {
  const {
    thumbDownFeedbackOptions,
    thumbUpFeedbackOptions,
    productFeedbackOptions,
  } = props;

  return thumbDownFeedbackOptions?.clientName || thumbUpFeedbackOptions?.clientName || productFeedbackOptions?.clientName || '';
};

let ocvInited = false;

export const useOcvFeedback = (props: IOCVFeedback = {
  initializeInAppFeedback: defaultInitializeInAppFeedback,
  updateFeedbackOptions: defaultUpdateFeedbackOptions,
  thumbDownFeedbackOptions: undefined,
  thumbUpFeedbackOptions: undefined,
  productFeedbackOptions: undefined,
  locale: 'en',
}) => {
  const {
    thumbDownFeedbackOptions,
    thumbUpFeedbackOptions,
    productFeedbackOptions,
    onFeedbackButtonClick,
    initializeInAppFeedback = defaultInitializeInAppFeedback,
    updateFeedbackOptions = defaultUpdateFeedbackOptions,
    locale,
  } = props || {};

  useEffect(() => {
    const feedbackInfo: InAppFeedBackInfo = {
      hostName: getHostName(props),
      language: locale || 'en',
    };

    if (!ocvInited) {
      ocvInited = true;
      initializeInAppFeedback(feedbackInfo);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFeedbackButtonClickWithOCVFeedback = useCallback((data: IFeedbackData, message: Message) => {
    const { currentFeedback } = data || {};
    if (currentFeedback === 'ThumbsDown' && thumbDownFeedbackOptions) {
      thumbDownFeedbackOptions.feedbackConfig = { ...thumbDownFeedbackOptions.feedbackConfig, isDisplayed: true };
      updateFeedbackOptions(thumbDownFeedbackOptions);
    } else if (currentFeedback === 'ThumbsUp' && thumbUpFeedbackOptions) {
      thumbUpFeedbackOptions.feedbackConfig = { ...thumbUpFeedbackOptions.feedbackConfig, isDisplayed: true };
      updateFeedbackOptions(thumbUpFeedbackOptions);
    }

    if (onFeedbackButtonClick) {
      onFeedbackButtonClick(data, message);
    }
  }, [onFeedbackButtonClick, thumbDownFeedbackOptions, thumbUpFeedbackOptions, updateFeedbackOptions]);

  const onProductFeedbackClick = useCallback(() => {
    if (productFeedbackOptions) {
      productFeedbackOptions.feedbackConfig = { ...productFeedbackOptions.feedbackConfig, isDisplayed: true };
      updateFeedbackOptions(productFeedbackOptions);
    }
  }, [productFeedbackOptions, updateFeedbackOptions]);

  return {
    onFeedbackButtonClick: onFeedbackButtonClickWithOCVFeedback,
    onProductFeedbackClick,
  };
};
